import { Component, ElementRef, OnInit, QueryList, ViewChild, ViewChildren } from '@angular/core';
import { HttpService } from 'src/app/modules/assetModule/shared/services/http.service';
import { UserService } from '../../../shared/user.service';
import { PublicKeyDetails } from 'src/app/models/PublicKeyDetails';
import { ExternalApplication } from 'src/app/models/ExternalApplication';
import { ApplicationKeyMapping } from 'src/app/models/ApplicationKeyMapping';
import { FormControl, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'app-l1',
  templateUrl: './l1.component.html',
  styleUrls: ['./l1.component.css']
})
export class L1Component implements OnInit {

  applicationKeyMapping: ApplicationKeyMapping;
  selectedApplicationId: string;
  disableViewSecretKey = false;
  errMessage: string = "";
  externalApplications: ExternalApplication[];
  previousMenu: any;
  applicationName: string;
  externalApp: any = {};
  ApplicationNameGroup: FormGroup;
  showSuccess: boolean;
  showSuccessMessage: string;
  theme_color: string;
  activeSinceDateDiff: string;
  requestedUserEmailId: string;
  isSuperUser: boolean;
  noAccessToApplication: boolean;
  users: any;
  masterUsers: any;
  prevApp: string;
  appId: string;
  searchWord: string = '';
  isAscending: boolean = true;
  sortColumn: string = 'name';
  downloadStarted: boolean;
  addApplicationPermission = false;
  externalApplicationOptions: ExternalApplication[];
  @ViewChild('selectedConsumers') selectedConsumerApp: ElementRef<any>;
  consumerApplication: Array<string>;
  tabIndex: number = 0;
  isConsumerAppModified: boolean = false;
  constructor(private httpService: HttpService, private userService: UserService) { }

  ngOnInit() {

    this.httpService.getBasePath().then(
      res => {
        this.getAllExternalApplications();
      }, err => {
        console.log(err);
      });

    this.httpService.themeChange.subscribe(
      data => {
        this.theme_color = data.themeType;
      }
    );

    this.ApplicationNameGroup = new FormGroup({
      ApplicationNameControl: new FormControl("", [Validators.required, Validators.minLength(1), Validators.pattern("^[a-zA-Z0-9_ ]*$")])
    });

  }

  requestSecretKey() {
    this.httpService.requestSecretKey(this.userService.loggendInUser.userEmailId, this.selectedApplicationId).
      subscribe((data: PublicKeyDetails) => {
        this.applicationKeyMapping.publicKeyDetails = data;
        this.calculateActiveSince(this.applicationKeyMapping.publicKeyDetails.keyGenerated);
      });
  }

  getSecretKey(ApplicationId, consumerApplications) {
    this.selectedApplicationId = ApplicationId;
    this.externalApplicationOptions = this.externalApplications.filter(x => x._id != this.selectedApplicationId);
    this.consumerApplication = this.getApplicationNames(consumerApplications);

    this.httpService.viewSecretKey(this.userService.loggendInUser.userEmailId, this.selectedApplicationId)
      .subscribe((data: ApplicationKeyMapping) => {
        this.applicationKeyMapping = data;
        this.calculateActiveSince(this.applicationKeyMapping.publicKeyDetails.keyGenerated);
      },
        err => {
          this.applicationKeyMapping = null;
          this.selectedApplicationId = "";
          if (err.status != 500) {
            this.errMessage = err.error;
            document.getElementById('key-error-modal').setAttribute('visible', 'true');
          }
        },
        () => {
          this.selectedConsumerApp.nativeElement.value = "";
          this.selectedConsumerApp.nativeElement.multiValue = [];  //Reset DropDown Menu
          for (let i = 0; i < this.selectedConsumerApp.nativeElement.children.length; i++) {
            this.selectedConsumerApp.nativeElement.children[i].removeAttribute('active');
          }

          let consumerApps = "";
          // Mark selected App 'active'
          if (this.consumerApplication) {
            let childNodeValue: HTMLCollection = this.selectedConsumerApp.nativeElement.children;
            for (let i = 0; i < childNodeValue.length; i++) {
              let isIncluded = this.consumerApplication.includes(childNodeValue[i].attributes['value'].value);
              if (isIncluded) {
                this.selectedConsumerApp.nativeElement.children[i].setAttribute('active', true);
              }
            }

            for (let i = 0; i < this.consumerApplication.length; i++) {
              const applicationName = this.consumerApplication[i];
              if (i < this.consumerApplication.length - 1) {
                consumerApps += applicationName + ",";
              }
              else {
                consumerApps += applicationName;
              }
            }
          }
          this.selectedConsumerApp.nativeElement.value = consumerApps;
        }
      );
  }
  changeActive(event) {
    var element = event.target;
    if (this.previousMenu != undefined && this.previousMenu != element) {
      this.previousMenu.removeAttribute("active");
    }
    element.setAttribute("active", "true");
    this.previousMenu = element;
    this.consumerApplication = null;    // Reset Consumer Application Array
    this.isConsumerAppModified = false;
  }

  getAllExternalApplications() {
    this.userService.getAllExternalApplication(this.userService.loggendInUser.userEmailId, this.userService.loggendInUser.applicationName)
      .subscribe(
        (res: any) => {
          this.addApplicationPermission = true;
          this.externalApplications = JSON.parse(res);
        }
        , error => {
          this.errMessage = error.error;
          document.getElementById('key-error-modal').setAttribute('visible', 'true');
        });
  }
  addExternalApplication() {
    this.externalApp.name = this.applicationName;
    this.userService.addExternalApplication(this.userService.loggendInUser.userEmailId, this.userService.loggendInUser.applicationName, this.externalApp).subscribe(
      (res: any) => {
        let newExternalApp = JSON.parse(res);
        this.selectedApplicationId = newExternalApp._id;
        this.externalApplications.push(newExternalApp);
        this.requestSecretKey();
        this.getSecretKey(this.selectedApplicationId, newExternalApp.consumers);
        this.successNotification("Application Added Successfully");
      },
      error => {
        this.errMessage = error.error;
        document.getElementById('key-error-modal').setAttribute('visible', 'true');
      }
    );
    this.ApplicationNameGroup.reset("");
  }

  calculateActiveSince(keyGenerated: Date) {
    let todaysDate = new Date();
    let keyGeneratedDate = new Date(keyGenerated);
    let diffInTime = todaysDate.getTime() - keyGeneratedDate.getTime();
    let diffinDays = Math.floor(diffInTime / (1000 * 3600 * 24));

    if (diffinDays === 0) {
      this.activeSinceDateDiff = "Today";
    } else {
      if (diffinDays < 30) {
        this.activeSinceDateDiff = diffinDays + " day(s) ago";
      } else {
        if (diffinDays >= 30 && diffinDays < 365) {
          this.activeSinceDateDiff = Math.floor(diffinDays / 30) + " month(s) ago";
        } else {
          this.activeSinceDateDiff = Math.floor(diffinDays / 365) + " year(s) ago";
        }
      }
    }
  }

  requestUnityPlugin() {

    // Add a check for userEmailId and selectedApplicationId
    var UnityPluginParameters = {
      "userEmailId": this.requestedUserEmailId,
      "applicationId": this.selectedApplicationId,
      "publicKeyXml": this.applicationKeyMapping.publicKeyDetails.publicKeyXml,
      "passphrase": this.applicationKeyMapping.publicKeyDetails.passphrase
    };
    this.successNotification("Your Request is Successfully Registered!");
    this.userService.requestUnityPlugin(UnityPluginParameters, this.userService.loggendInUser.userEmailId, this.userService.loggendInUser.applicationName)
      .subscribe(data => {
        console.log(data);
        let fileElement = document.createElement("a"),
          url = URL.createObjectURL(new Blob([data], { type: "application/zip" }));
        fileElement.href = url;
        fileElement.download = "UnityPlugin.zip";
        document.body.appendChild(fileElement);
        fileElement.click();
        this.downloadStarted = false;
        setTimeout(function () {
          document.body.removeChild(fileElement);
          window.URL.revokeObjectURL(url);
        }, 0);
      });
  }

  checkIfUserIsSuperUser(selectedApplicationId: string) {
    this.isSuperUser = false;
    this.userService.loggendInUser.applicationName.forEach((app) => {
      if (app.application == selectedApplicationId && app.userGroup == 'SuperUser') {
        this.isSuperUser = true;
      }
    });
  }

  getUsers(app: any) {
    this.checkIfUserIsSuperUser(app);
    if (app == this.prevApp)//if the currently clicked application is same as the one before clicked.
      return;
    this.appId = app;
    // this.getUserGroupsByApplicationId(this.appId);
    this.userService.getExternalUsers(app).subscribe((res) => {
      this.noAccessToApplication = false;
      var jsonString = JSON.stringify(res);//cloning to avoid reference issues
      this.users = JSON.parse(jsonString); // this list will be renedered in the html
      this.masterUsers = JSON.parse(jsonString);//keeping a copy of users for search operations.
      this.prevApp = app;//to avoid calling api for same application selection.
      this.search(null, this.searchWord);
    }, (err: any) => {
      this.prevApp = app;
      this.users = [];
      this.masterUsers = [];
      if (err.status == 403) {
        this.noAccessToApplication = true;
      }
    }
    );
  }

  search(event: KeyboardEvent, word: string = '') {
    this.searchWord = event == null ? word : event.target['value'];
    this.users = [];
    this.masterUsers.forEach(element => {
      element.userGroup = element.userGroup == null ? "" : element.userGroup;
    });
    this.masterUsers.forEach(user => {
      if (user.userEmailId.toLowerCase().includes(this.searchWord.toLowerCase()) || user.name.toLowerCase().includes(this.searchWord.toLowerCase())
        || user.userGroup.toLowerCase().includes(this.searchWord.toLocaleLowerCase())) //if search word contains anything from Emailid,name,usergroup it would then show up in the grid.
        this.users.push(user);
    });
    this.doActualSort();//keeping sort intact after clearing search.
  }

  doActualSort() {
    this.users.forEach(element => {
      if (element.name == null)
        element.name = "";
    });
    this.users.sort((valA, valB) => {
      if (this.isAscending)
        return valA[this.sortColumn].toLowerCase().charCodeAt(0) - valB[this.sortColumn].toLowerCase().charCodeAt(0);
      else
        return valB[this.sortColumn].toLowerCase().charCodeAt(0) - valA[this.sortColumn].toLowerCase().charCodeAt(0);
    });
  }

  successNotification(message: string) {
    this.showSuccess = true;
    this.showSuccessMessage = message;
    setTimeout(() => {
      this.showSuccess = false;
    }, 5000);
  }
  onSelectedConsumerApp() {
    this.consumerApplication = this.selectedConsumerApp.nativeElement.multiValue;
    this.isConsumerAppModified = true;
  }

  onRemoveSelectedApp(applicationName: string, index: number) {
    this.isConsumerAppModified = true;
    let childNodeValue: HTMLCollection = this.selectedConsumerApp.nativeElement.children;
    for (let i = 0; i < childNodeValue.length; i++) {
      if (childNodeValue[i].attributes['value'].value === applicationName) {
        this.selectedConsumerApp.nativeElement.children[i].removeAttribute('active');
        break;
      }
    }

    this.consumerApplication.splice(index, 1);
    let selectedAppDropdown = "";
    for (let i = 0; i < this.consumerApplication.length; i++) {
      const applicationName = this.consumerApplication[i];
      if (i < this.consumerApplication.length - 1) {
        selectedAppDropdown += applicationName + ",";
      }
      else {
        selectedAppDropdown += applicationName;
      }
    }
    this.selectedConsumerApp.nativeElement.value = selectedAppDropdown;
  }

  saveConsumerApplication() {
    const consumerApplicationIds = [];
    this.consumerApplication.forEach(app => {
      let index = this.externalApplications.findIndex(x => x.name === app);
      if (index >= 0) {
        consumerApplicationIds.push(this.externalApplications[index]._id);
      }
    });
    this.userService.addConsumerApplication(this.userService.loggendInUser.userEmailId, this.userService.loggendInUser.applicationName, consumerApplicationIds, this.selectedApplicationId)
      .subscribe(
        (response) => {
          this.successNotification("Successfully Added/Modified Consumer Application.");
        },
        error => {
          console.log(error);
        },
        () => {
          this.getAllExternalApplications();
        }
      );
  }

  getApplicationNames(applicationIds: Array<string>) {
    if (applicationIds == null) return null;
    let applicationNames = [];
    applicationIds.forEach(appId => {
      let index = this.externalApplications.findIndex(x => x._id === appId);
      if (index >= 0) {
        applicationNames.push(this.externalApplications[index].name);
      }
    });

    return applicationNames;
  }

  // onTabChanged(index: number)
  // {
  //   if(index === 0)
  //   {
  //     this.tabIndex = 0;
  //   }
  //   else if(index === 1)
  //   {
  //     this.tabIndex = 1;
  //   }

  // }
}
